export const MENTION_ALLOWED_CHARS = /^[A-Za-z\sÅÄÖåäö]*$/;
